import { useGetOutgoingPostbackQuery } from "api/TenantSlug/OutgoingPostback/hooks";
import { TrackingTooToEditorForm } from "components/Forms/TrackingTooToEditorForm/TrackingTooToEditorForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getTrackingToolToItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor-old/"
)({
    component: TrackingToolToEditorOldPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingOutgoingEditEditor],
        showInSideMenu: false,
        label: "pages.tool.tracking.to.editor-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.tracking.to.editor-old.title"),
        };
    },
});

function TrackingToolToEditorOldPage() {
    const { id } = Route.useParams();
    const { data, isLoading, isError } = useGetOutgoingPostbackQuery(id, {});
    const outgoingPostback = data?.outgoingPostback;
    const userUtils = useUser();
    const formId = FormId.TrackingToolToEditorForm;

    if (!outgoingPostback) {
        return (
            <QueryState
                isLoading={isLoading}
                isError={isError || !isLoading}
                errorKey="errors.loading_outgoing_postback"
            />
        );
    }

    return (
        <TenantPage
            headerNavigationItems={() => getTrackingToolToItems()}
            isEdit
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? formId
                    : null
            }
        >
            <SectionContentWrapper withBackground>
                <TrackingTooToEditorForm key={id} postback={outgoingPostback} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
